export const systemRoles = [
    {
        label: '系统管理员',
        value: 'Admin'
    },
    {
        label: '运营人员',
        value: 'Operator'
    }
]